export default __webpack_public_path__ + "static/media/GP.15de05ad.jpg";